import * as React from "react";
import { QESButton } from "../qes-standards";

interface ActionMenuItemStandardProps {
  displayText: string;
  faIcon?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export default class ActionMenuItemStandard extends React.Component<ActionMenuItemStandardProps> {
  constructor(props: ActionMenuItemStandardProps) {
    super(props);
  }

  public render() {
    const classes = this.props.faIcon ? `fa ${this.props.faIcon} pr-1` : "pr20 ml3";
    return (
      <QESButton
        qesType="none"
        qesTestId={`action-menu-item--${this.props.displayText}`}
        className={`col-md-12 action-menu-item d-block font-weight-normal ${this.props.disabled ? "disabled" : null}`}
        onClick={this.handleClick}
      >
        <i className={classes} />{this.props.displayText}
      </QESButton>);
  }

  private handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (this.props.onClick && !this.props.disabled) {
      this.props.onClick(e);
    }
  }
}
